<template>
	<div>
		<v-row>
			<v-col class="d-flex flex-wrap">
				<!--v-if="!isLoadingAggiornamenti"-->
				<div
					v-for="(data, key) in aggiornamenti"
					class="ml-1 mb-1"
				>
					<!--<v-badge-->
					<!--	:key="key"-->
					<!--	:value="data.ci_sono_aggiornamenti_fase"-->
					<!--	color="secondary"-->
					<!--	dot-->
					<!--	overlap-->
					<!--	right-->
					<!--&gt;-->
					<!--	<v-badge-->
					<!--		:key="key"-->
					<!--		:value="isAccountManager-->
					<!--			&& key == 'ci_sono_aggiornamenti_fase_1'-->
					<!--			&& ci_sono_aggiornamenti_per_account_manager_fase_1"-->
					<!--		color="pink lighten-1"-->
					<!--		dot-->
					<!--		overlap-->
					<!--		left-->
					<!--	>-->
					<!--		&lt;!&ndash;prima era così:&ndash;&gt;-->
					<!--		&lt;!&ndash;&& pratica.ci_sono_aggiornamenti_per_account_manager_fase_1"&ndash;&gt;-->
					<!--		<v-btn-->
					<!--			x-small-->
					<!--			:color="data.colore_dello_stato"-->
					<!--			@click="tourIsRunning ? null : openPraticaTab(key.slice(-1))"-->
					<!--		>-->
					<!--			<span class="white&#45;&#45;text">Fase {{ key.slice(-1) }}</span>-->
					<!--		</v-btn>-->
					<!--	</v-badge>-->
					<!--</v-badge>-->
					
					<button
						@click="tourIsRunning ? null : openPraticaTab(key.slice(-1))"
						type="button"
						:style="{ backgroundColor: data.colore_dello_stato }"
						class="fase-btn"
					>
						<span class="white--text">
							Fase {{ key.slice(-1) }}
						</span>
						
						<!-- Badge generale-->
						<span
							v-if="data.ci_sono_aggiornamenti_fase"
							class="badge badge-update"
						></span>
						
						<!-- 2️⃣ Pallino solo AM / fase 1 -->
						<span
							v-if="isAccountManager && key === 'ci_sono_aggiornamenti_fase_1' && ci_sono_aggiornamenti_per_account_manager_fase_1"
							class="badge badge-am"
						></span>
					</button>
				</div>
			</v-col>
		</v-row>
		
		<!--<v-dialog-->
		<!--	:value="praticaDialog"-->
		<!--	persistent-->
		<!--	scrollable-->
		<!--&gt;-->
		<!--	<store-edit-view-pratica-->
		<!--		:key="praticaKey"-->
		<!--		v-model="pratica"-->
		<!--		:fasi-with-stati="fasiWithStati"-->
		<!--		:active-tab-index="faseId"-->
		<!--		:action="action"-->
		<!--		:accordo-id="accordoId"-->
		<!--		:contratto-di-servizio-id="contrattoDiServizioId"-->
		<!--		@close="praticaDialog = false"-->
		<!--		@reload-pratiche="$emit('reload-pratiche')"-->
		<!--		@reload-accordi="$emit('reload-accordi')"-->
		<!--		@reload-contratti-di-servizio="$emit('reload-contratti-di-servizio')"-->
		<!--		@aggiornamenti-visualizzati="$emit('aggiornamenti-visualizzati', $event)"-->
		<!--	></store-edit-view-pratica>-->
		<!--</v-dialog>-->
	</div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
	props: [
		'aggiornamenti',
		'ci_sono_aggiornamenti_per_account_manager_fase_1'
		// 'pratica',
		// 'accordoId', // quando nella pagina Accordi si apre il v-dialog con le pratiche di quell'accordo
		// 'contrattoDiServizioId' // quando nella pagina Contratti di servizio si apre il v-dialog con le pratiche di quel contratto
	],
	
	data() {
		return {
			// isLoadingAggiornamenti: true,
			// aggiornamenti: []
		}
	},
	
	created() {
		// this.calcolaAggiornamenti();
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			// fasiWithStati: 'fasi/fasiWithStati',
			// isLoadingStatiWithFasi: 'fasi/isLoading',
			// statiColorMap: 'fasi/statiColorMap',
			// fasiDelBandoAttivo: 'fasi/fasiDelBandoAttivo',
			tourIsRunning: 'tour/isRunning'
		}),
		// fasiAttive() {
		// 	let fasiAttive = []
		// 	for (const key in this.fasiWithStati) {
		// 		fasiAttive.push(this.fasiWithStati[key].ordinamento);
		// 	}
		// 	return fasiAttive;
		// },
		// aggiornamenti() {
		// 	if (this.isLoadingStatiWithFasi) return [];
		// 	return Object.keys(this.pratica)
		// 		.filter((key) => key.includes('ci_sono_aggiornamenti_fase') && this.fasiAttive.some(faseAttiva => key.endsWith(faseAttiva)))
		// 		.reduce((obj, key) => {
		// 			const numeroFase = key.slice(-1);
		// 			return Object.assign(obj, {
		// 				[key]: {
		// 					ci_sono_aggiornamenti_fase: this.pratica[key],
		// 					colore_dello_stato: this.fasiWithStati.find(fase => fase.ordinamento == numeroFase)
		// 						?.stati.find(stato => stato.id == this.pratica[`id_stato_fase_${numeroFase}`])
		// 						.codice_colore
		// 				}
		// 			});
		// 		}, {});
		// },
	},
	
	// watch: {
	// 	isLoadingStatiWithFasi (newVal) {
	// 		if (!newVal) {
	// 			this.calcolaAggiornamenti()
	// 		}
	// 	}
	// },
	
	methods: {
		openPraticaTab(faseId) {
			this.$emit('open-pratica-tab-anteprima-stato-fasi', faseId);
		},
		/**
		 * NUOVO METODO CREATO CON CHATGPT
		 * https://chatgpt.com/c/68595c34-8db8-8007-be8e-7aae883ef275
		 */
		// calcolaAggiornamenti() {
		// 	console.log('calcolaAggiornamenti')
		//
		// 	this.isLoadingAggiornamenti = true;
		//
		// 	this.aggiornamenti = Object.keys(this.pratica)
		// 		.filter(key =>
		// 			key.startsWith('ci_sono_aggiornamenti_fase') &&
		// 			this.fasiDelBandoAttivo.has(+key.slice(-1)) // lookup O(1)
		// 		)
		// 		.reduce((out, key) => {
		// 			const faseN = +key.slice(-1)
		// 			const statoId = this.pratica[`id_stato_fase_${faseN}`]
		// 			out[key] = {
		// 				ci_sono_aggiornamenti_fase: this.pratica[key],
		// 				colore_dello_stato: this.statiColorMap[statoId] || ''
		// 			}
		// 			return out
		// 		}, Object.create(null))                     // risultato minimale
		//
		// 	this.isLoadingAggiornamenti = false;
		// },
		/**
		 * VECCHIO METODO CHE OCCUPAVA TANTA MEMORIA
		 */
		// calcolaAggiornamenti() {
		// 	console.log('calcolaAggiornamenti')
		//
		// 	this.isLoadingAggiornamenti = true;
		//
		// 	let fasiAttive = []
		// 	for (const key in this.fasiWithStati) {
		// 		fasiAttive.push(this.fasiWithStati[key].ordinamento);
		// 	}
		//
		// 	this.aggiornamenti = Object.keys(this.pratica)
		// 		.filter((key) => key.includes('ci_sono_aggiornamenti_fase') && fasiAttive.some(faseAttiva => key.endsWith(faseAttiva)))
		// 		.reduce((obj, key) => {
		// 			const numeroFase = key.slice(-1);
		// 			return Object.assign(obj, {
		// 				[key]: {
		// 					ci_sono_aggiornamenti_fase: this.pratica[key],
		// 					colore_dello_stato: this.fasiWithStati.find(fase => fase.ordinamento == numeroFase)
		// 						?.stati.find(stato => stato.id == this.pratica[`id_stato_fase_${numeroFase}`])
		// 						.codice_colore
		// 				}
		// 			});
		// 		}, {});
		//
		// 	this.isLoadingAggiornamenti = false;
		// }
	}
}
</script>

<style scoped>
.fase-btn {
	/* dimensioni simili a v-btn x-small  */
	min-width: 52px;
	min-height: 20px;
	//padding: 0 4px;
	//padding-top: 2px;
	font-size: 11px;
	line-height: 21px;
	color: #fff;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	position: relative;
}

.fase-btn:focus-visible {
	outline: 2px solid #fff5;   /* sostituto del ripple */
}

.fase-btn:hover { filter: brightness(1.1); }

.badge {
	position: absolute;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	top: -1px;
	right: -2px;
}

.badge-update { background:#f1861b; }

/* badge rosa account-manager */
.badge-am {
	background:#ec407a;
	top: -1px;
	left: -1px;
}
</style>